<template>
  <div>
    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
        <p class="title"><strong>Pesquisa</strong></p>
        <form class="mt-1 w-full" @submit.prevent="reloadTable">
          <div class="flex flex-wrap mb-4 px-4">
            <text-input 
              class="lg:pr-6 w-full lg:w-1/4" 
              label="Nome" 
              v-model="filters.Zone.name" />
          </div>

          <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
            <button 
              class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
                <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                Pesquisar
            </button>

            <button
              class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100" @click="clearSearch">
                <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                Limpar
            </button>
          </div>
        </form>
    </div>
    <Head title="Regiões" />
    <div class="shadow_box rounded-lg p-6 mt-4">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Regiões</h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="zone/list"
        :query="getQuery"
        no-data-label="Nenhuma região cadastrada"
        no-result-label="Nenhuma região encontrada"
      >
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
            </span>

            <span @click="openModalConfirmDelete(row)" class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" />Excluir
            </span>
          </div>
        </template>

        <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
              <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
                <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
              </span>

              <span @click="openModalConfirmDelete(row)" class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir
              </span>
            </div>
        </template>

        <template #after.reload-button>
          <button class="flex items-end font-roboto font-medium btn-purple uppercase" @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" />
            <span class="hidden lg:block"> Adicionar Região</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" title="Regiões" url="zone" @submitForm="reloadTable">
      <template #form="{item}">
        <text-input v-model="item.name" :error="item.errors.name"
        required="true"
        class="lg:pr-6 w-full lg:w-3/4" label="Nome" />
      </template>
    </modal-edit>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    TextInput,
    DataTable,
  },
  layout: Layout,
  data() {
    return {
      loadTable: true,
      search: {
          name: '',
      },
      columns: [
        {
          uniqid: 'zone_name',
          label: 'Nome da região',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'market',
          label: 'NÚMERO DE LOJAS',
          field: 'market',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },

  computed: {
    getQuery() {
      return Object.entries( this.getFilters() ).map( ( [key, val] ) => `search2[${key}]=${val}` ).join( '&' )
    },
  },

  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/zone/update-status", item);
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/zone/${item.id}`, `Deseja realmente excluir a região ${item.name}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        name: item.name,
        errors: {}
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    clearSearch() {
      this.clearFilters()
      this.reloadTable()
    },
  },

  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent( 'Zone' )

    const clearFilters = () => clearFiltersComponent( 'Zone' )
    const getFilters = () => getFiltersComponent( 'Zone' )

    return { 
      getFilters,
      clearFilters, 
      filters: filtersStore.filters
    }
  }
}
</script>
